export enum AdminEventError {
	EVENT_ERROR = 'There was an error loading Event. Please try again.',
	DELETE_ERROR = 'Error deleting Event',
	EDIT_ERROR = 'Error editing Event',
	CREATE_ERROR = 'Error creating Event',
	NAME_ERROR = 'Event name is required',
	DESCRIPTION_ERROR = 'Event description is required',
}